import BaseApi from './base/BaseApi';

export default class TaskStatusApi extends BaseApi {
  static entityName = 'task_statuses';
}
